import { Grid2 as Grid, Typography } from "@mui/material"
import { getAllSpecializationAreasReq } from "../../../../../redux/guest-slices/common.slice"
import InputField1 from "../../../../../components/ui/InputField1"
import { Fragment, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import FileInput from "../../../../../components/ui/FileInput"
import SpecializationAreas from "../../../../../components/ui/SpecializationAreas"
import { validateNumber } from "../../../../../utils/velidations"

function SleepCoach({ errors, files, onChangFun }) {
  const dispatch = useDispatch()
  const [areas, setAreas] = useState([])
  const { specialist } = useSelector(state => state.specialistSlice)

  const handleGetAreas = (filters) => {
    dispatch(getAllSpecializationAreasReq({
      limit: filters?.limit || 10,
      id: "67d90056c2c4d5ab747f8b3a"
    })
    ).unwrap().then((data) => {
      setAreas(data)
    }).catch(() => { })
  }

  useEffect(() => {
    handleGetAreas()

    // eslint-disable-next-line
  }, [])

  return (
    <Fragment>
      <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
        <FileInput
          files={files}
          errors={errors}
          name="specializationCertificate"
          label="Medical or Therapeutic Qualifications Related to Sleep *"
          defaultValue={specialist?.profile?.specializationCertificate || []}
          errText="Please enter medical or therapeutic qualifications related to sleep"
          placeholderText="Upload Medical or Therapeutic Qualifications Related to Sleep"
        />
      </Grid>

      <Grid size={12}>
        <SpecializationAreas
          areas={areas}
          errors={errors}
          onChangFun={onChangFun}
          label="Specialization Areas *"
        />
      </Grid>

      <Grid size={12}>
        <InputField1
          type="text"
          errors={errors}
          name="experience"
          onChangeFun={validateNumber}
          label="Professional Experience *"
          placeholder="Enter Professional Experience *"
          errText="Please enter professional experience"
          defaultValue={specialist?.profile?.experience || ""}
        />
      </Grid>

      <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
        <FileInput
          files={files}
          errors={errors}
          name="additionalCertificates"
          label="Section for Credentials"
          placeholderText="Upload Additional Certificates"
          defaultValue={specialist?.profile?.additionalCertificates || []}
        />
      </Grid>

      <Typography
        color="#7A8A9E"
        fontWeight="500"
        fontStyle="italic"
      >As a Sleep Specialist, your knowledge in addressing sleep issues is crucial. Provide your qualifications and experience to assist our members in achieving healthy sleep habits
      </Typography>
    </Fragment>
  )
}

export default SleepCoach